import { CallOutTextFragmentFragment } from '../../__generated__/graphql';
import Divider from '../../components/Divider';
import { GradientText, Paragraph } from '../../components/Text';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

import style from './callout-text.module.css';

const CalloutText: ContentBlock<CallOutTextFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.calloutText;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor="black"
      id={contentBlockProps.sectionId}
    >
      <Divider
        thickness={2}
        variant="gradient"
      />

      <div className={style.calloutTextBlock}>
        <GradientText
          as="h2"
          className={style.calloutTextTitle}
        >
          {contentBlockProps.title}
        </GradientText>

        <Paragraph
          className={style.calloutTextText}
          fontSize={20}
          fontWeight={300}
        >
          {contentBlockProps.text}
        </Paragraph>
      </div>

      <Divider
        thickness={2}
        variant="gradient"
      />
    </Section>
  );
};

export default CalloutText;
